"use client";

import { createContext, useContext } from "react";
import type { DocumentCardVariant } from "./document-card";

export interface DocumentCardContextValue {
  variant: DocumentCardVariant;
}

export const DocumentCardContext = createContext<DocumentCardContextValue | null>(null);

export const useDocumentCard = (): DocumentCardContextValue => {
  const ctx = useContext(DocumentCardContext);
  if (!ctx) throw new Error("DocumentCard parts must be used within <DocumentCard>.");
  return ctx;
};
